'use client';

import { useStrictContext } from '@cc-shopping/hooks/useStrictContext';
import { usePathname } from 'next/navigation';
import { createContext, type PropsWithChildren, useEffect, useRef, useState } from 'react';

export type ReferrerContextValue = {
  referrer: string | null;
  isInitialPageLoad: boolean;
  setInitialPageLoaded: () => void;
};

export const ReferrerContext = createContext<ReferrerContextValue | null>(null);

export function ReferrerProvider({ children }: PropsWithChildren) {
  const pathname = usePathname();
  const [referrer, setReferrer] = useState<string | null>(null);
  const lastPathnameRef = useRef<string | null>(null);
  const isInitialPageLoadRef = useRef(true);

  useEffect(() => {
    if (lastPathnameRef.current !== pathname) {
      setReferrer(window.location.href);
    }

    lastPathnameRef.current = pathname;
  }, [pathname]);

  return (
    <ReferrerContext.Provider
      value={{
        referrer,
        isInitialPageLoad: isInitialPageLoadRef.current,
        setInitialPageLoaded: () => {
          isInitialPageLoadRef.current = false;
        },
      }}
    >
      {children}
    </ReferrerContext.Provider>
  );
}

export function useReferrerContext() {
  return useStrictContext(ReferrerContext);
}
